import { ReadWriteApi } from './readWriteApi';

export function createInMemoryApi<T>(initialData: T): ReadWriteApi<T> {
  let data = initialData;
  return {
    load: () => data,
    unsafeRawLoad: () => data,
    save: newData => {
      data = newData;
    },
    reset: () => {
      data = initialData;
    }
  };
}
